export default {
  Resume: {
    im: '{fullName}',
    aboutMe: 'À propos de moi',
    aboutMeSubtitle: 'Une petite introduction sur moi',
    download: 'Télécharger',
    hireMe: 'Engagez-moi',
    workExperienceAndEducation: 'Expérience professionnelle et éducation',
    workExperienceAndEducationSubtitle:
      'Mes précédents et actuels emplois ainsi que mes études.',
    years: '{years, plural, =0 {0 an} one {# an} other {# ans}}',
    year: ' an',
    skills: 'Compétences',
    skillsSubtitle: "Je peux dire que je suis plutôt à l'aise avec",
    languages: 'Langues',
    languagesSubtitle: 'Je parle',
    interests: 'Loisirs',
    interestsSubtitle: "Ce que j'aime",
    resume: 'CV',
    projectsAndDevelopments: 'Projets et développements',
    projectsAndDevelopmentsSubtitle:
      'Mes derniers travaux, projets et développements.',
    tools: 'Outils',
    toolsSubtitle: 'Mes outils préférés',
    showMore: 'Voir plus',
    showLess: 'Voir moins',
  },
  WaitingUntilJapanScreen: {
    remainingDaysUntilJapan: 'Jours restants avant Japon',
    from: 'De',
    until: "Jusqu'à",
    days: 'Jours',
    Percent: 'Pourcentage',
  },
  SimpleBottomNavigation: {
    aboutMe: 'À propos de moi',
    home: 'Accueil',
    workExperience: 'Expérience',
    education: 'Education',
    skills: 'Compétences',
    languages: 'Langues',
    hobbies: 'Loisirs',
    projects: 'Projets',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/fr.js